import WorkRoundedIcon from '@mui/icons-material/WorkRounded';
import comercialList from './comercialList';
const ComercialModule = {
    list: comercialList,
    icon: WorkRoundedIcon,
}; export default ComercialModule;